import React from 'react';
import { AppBar, createStyles, makeStyles, Grid } from '@material-ui/core';
import Toolbar from '@material-ui/core/Toolbar';
import TaxiLogoJP from './../../images/logo.png';
import TaxiLogoEN from './../../images/logoEN.png';
import { useTranslation } from 'react-i18next';
import { changeLang, Lang } from '../../../../../../states/query';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      flexGrow: 1,
      padding: 0,
    },
  }),
);

/** ハイヤー・タクシー予約画面用のヘッダー。 */
const TaxiAndHireHeader: React.FC = () => {
  const classes = useStyles({});
  const { i18n } = useTranslation();
  const lang = changeLang(i18n.language);
  const alt = lang === Lang.ja? '空港アクセスナビ ハイヤー・タクシー予約 ロゴ': 'Airport Access Navi Hire/taxi Reservation Logo';
  const TaxiLogo = lang === Lang.ja? TaxiLogoJP: TaxiLogoEN;

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Toolbar>
          <Grid container direction='column' alignItems='center'>
            <Grid item>
              {/* タクシー予約用のロゴを表示。現状日本語版のみ。（2021/07/15現在） */}
              <img
                src={TaxiLogo}
                alt={alt}
                style={{ maxHeight: "60px" }}
              />
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </div>
  )
}

export default TaxiAndHireHeader;
